__turbopack_context__.v({
  "showMoreButton": "show-more-button-module-scss-module__kWttVa__showMoreButton",
  "showMoreButton_active": "show-more-button-module-scss-module__kWttVa__showMoreButton_active",
});
